import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: 1100px;
  border-radius: 10px;
  border: 2px solid #0085a3;
  padding: 20px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
  text-align: center;

  p {
    font-size: 1.2rem;
  }
  .number{
    color: #99004d;
    font-size: 1.7rem;
  }
  .question{
    font-size: 1.3rem;
    color: #fff;
    text-decoration: violet;
    background: linear-gradient(90deg, #56ccff, #6eafb4);
    border-radius: 10px;
    border: 3px solid #99004d;
    padding: 10px;
  }
`
type ButtonWrapperProps = {
  correct: boolean;
  userClicked: boolean;
}

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  transition: all 0.3s ease;

  :hover{
    opacity: 0.8;
  }

  button{
    cursor: pointer;
    user-select: none;
    font-size: 1rem;
    width: 100%;
    min-height:40px;
    margin: 5px 0;
    background:${props => 
    props.correct
    ? 'linear-gradient(90deg, #56ffa4, #59bc86)'
    : !props.correct && props.userClicked 
    ? 'linear-gradient(90deg, #ff5656, #c16868)'
    : 'linear-gradient(90deg, #56ccff, #6eafb4)'};
    border: 3px solid #fff;
    box-shadow: 1px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;  
    text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.25);
  }`;